module.exports = __webpack_public_path__ + "img/4.3e6f8e0b.gif";